import { render, staticRenderFns } from "./ActionHabitsDash.vue?vue&type=template&id=72339ca2&scoped=true&"
import script from "./ActionHabitsDash.vue?vue&type=script&lang=js&"
export * from "./ActionHabitsDash.vue?vue&type=script&lang=js&"
import style0 from "./ActionHabitsDash.vue?vue&type=style&index=0&id=72339ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72339ca2",
  null
  
)

export default component.exports